import { fromApiBoolean } from '@liquidweb-dev/club-sauce';
import type { LWApiPublicAssetDetailsResultRawI } from '@liquidweb-dev/club-sauce/public/asset/index.raw';

type Capabilities = LWApiPublicAssetDetailsResultRawI['capabilities'];

/**
 * Whether the asset reports a reboot capability at all. Either one counts:
 * `autoReboot` means the platform can power-cycle the asset itself, which is
 * what the force option in the reboot drawer does, and `manReboot` covers the
 * assets that reboot through a request instead, which most dedicated servers
 * report on their own.
 *
 * Both the servers list menu item and the detail page's primary button read
 * this, so an asset is offered reboot on both surfaces or on neither. Callers
 * add their own conditions on top: the menu checks its intent, the detail page
 * checks the power status, and both exclude a private parent.
 */
const canReboot = (capabilities: Capabilities) =>
	fromApiBoolean(capabilities?.manReboot) ||
	fromApiBoolean(capabilities?.autoReboot);

export default canReboot;
